import { CHAT_CONVERSATION_TYPES } from '@/utils/constants';

/** Verifica se o senderId (ex: "PF:12345") corresponde ao ID numérico do usuário logado. */
export const isMyMessage = (senderId: string, myId: number): boolean =>
  Number.parseInt(senderId.replace(/\D/g, '') || '0') === myId;

/** Retorna o tipo de conversa ("from"/"to") com base no índice da tab (0 = compra, 1 = venda). */
export const getConversationType = (tabIndex: number = 0): 'from' | 'to' =>
  tabIndex === 1 ? CHAT_CONVERSATION_TYPES.sale : CHAT_CONVERSATION_TYPES.purchase;

/** Traduz o status da mensagem (sent/read/received) para português, considerando se é do próprio usuário. */
export const formatStatusMessage = (
  statusMessage: string | undefined,
  itsMyMessage: boolean,
): string | undefined => {
  if (statusMessage === 'sent' && itsMyMessage) return 'enviada';
  if (statusMessage === 'read') return 'lida';
  if (statusMessage === 'received') return 'recebida';
  return undefined;
};
